import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    selector: "existing-form-data-draft",
    template: `
        <ng-container>
            <p-messages severity="info" [closable]="true">
                <ng-template pTemplate="content">
                    <div class="flex flex-column">
                        <p class="primary-message">
                            <i class="mi mi-info mr-1"> </i>

                            <span>
                                There's a draft of this form data. Would you like to
                            </span>

                            <p-button
                                label="Apply"
                                icon="pi pi-search"
                                styleClass="p-button-sm p-button-rounded ml-1 mr-1"
                                (onClick)="applyDraft()">
                            </p-button>

                            <span>or </span>

                            <p-button
                                label="Discard"
                                icon="mi mi-button-remove"
                                styleClass="p-button-sm p-button-rounded p-button-danger ml-1 mr-1"
                                (onClick)="discardDraft()">
                            </p-button>

                            <span>it? </span>
                        </p>
                    </div>
                </ng-template>
            </p-messages>
        </ng-container>
    `,
    styleUrls: ["./existing-form-data-draft.component.scss"]
})
export class ExistingFormDataDraftComponent {
    
    @Output() readonly apply = new EventEmitter();
    @Output() readonly discard = new EventEmitter();

    applyDraft() {
        this.apply.emit();
    }

    discardDraft() {
        this.discard.emit();
    }
}